"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _productShades = require("./productShades");
Object.keys(_productShades).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _productShades[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _productShades[key];
    }
  });
});